import { ColumnTypes } from '../../../src/components/table/columnTypes';
import { createSelector } from '@opengov/compose-app/reselect';
import { createReportConfigurationDimensionalSummaryQuery, SortDirection } from '@opengov/reporting-types';

import { reportConfigurationActionCreators } from '../../../module/state';
import { reportConfigurationEffects } from '../../common/reportConfiguration/effects/reportConfigurationEffects';
import { selectCurrentReportConfiguration } from '../../common/reportConfiguration/selectors';
import { selectDimensionalRowsColumn } from '../../reportExplorer/selectors/selectReportDimension';

export interface IDimensionalFilterProps {
  columnName: string | null;
  columnType: string;
  sortColumn: string | null;
  sortDirection: SortDirection | null;
  onClearSort(): void;
  onSortAsc(columnName: string): void;
  onSortDesc(columnName: string): void;
}

export const selectDimensionalSummaryQuery = createSelector(selectCurrentReportConfiguration, (reportConfig) => {
  return reportConfig && reportConfig.dimensionalSummaryQueries.length > 0
    ? reportConfig.dimensionalSummaryQueries[0]
    : null;
});

// this is highly focused on how the CoA summary table works currently with the single
// auto column to sort on.  It will not apply to other columns.
export const selectDimensionalTreeFilterProps = createSelector(
  selectDimensionalRowsColumn,
  selectDimensionalSummaryQuery,
  (rowsColumn, summaryQuery): IDimensionalFilterProps => {
    const sortDirection = summaryQuery?.sortDirection ?? null;
    const sortColumn = summaryQuery?.sortColumnName ?? null;

    return {
      columnName: rowsColumn?.name ?? null,
      columnType: ColumnTypes.Text,
      sortColumn,
      sortDirection,
      onClearSort: () => {
        const defaultRecord = createReportConfigurationDimensionalSummaryQuery();
        const payload = { columnName: defaultRecord.sortColumnName, direction: defaultRecord.sortDirection };
        reportConfigurationActionCreators.setDimensionalSortColumn(payload);
        void reportConfigurationEffects.createReportConfigurationAndUpdateUrl();
      },
      onSortAsc: (columnName) => {
        const payload = { columnName, direction: SortDirection.ASC };
        reportConfigurationActionCreators.setDimensionalSortColumn(payload);
        void reportConfigurationEffects.createReportConfigurationAndUpdateUrl();
      },
      onSortDesc: (columnName) => {
        const payload = { columnName, direction: SortDirection.DESC };
        reportConfigurationActionCreators.setDimensionalSortColumn(payload);
        void reportConfigurationEffects.createReportConfigurationAndUpdateUrl();
      }
    };
  }
);
